// extracted by mini-css-extract-plugin
module.exports = {"readMore":"styles-styles-module--readMore--1oSps","readAll":"styles-styles-module--readAll--22QLm"};